import React from 'react';
import firebase from '../helper/firebase';

import { Link } from 'react-router-dom';

import Head from '../components/Head';
import JobCardHeader from '../components/JobCardHeader';
import Snack from '../components/Snack';
import JobCardReferees from '../components/JobCardReferees';
import UnpublishedJob from '../components/UnpublishedJob';
import LoggedOutCard from '../components/LoggedOutCard';
import SectionTitle from '../components/SectionTitle';
import ApplicantCardHeader from '../components/ApplicantCardHeader';
import SkillsChips from '../components/SkillsChips';
import { Title } from '../helper/consts';

import {
	Button,
	CircularProgress,
	Card,
	CardActions,
	CardContent,
	CardHeader,
	Divider
} from 'material-ui';

import {
	List,
	ListSubheader,
	ListItem,
	ListItemIcon,
	ListItemText
} from 'material-ui';

import Fade from 'material-ui/transitions/Fade';
import Collapse from 'material-ui/transitions/Collapse';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';
import ExpandLessIcon from 'material-ui-icons/ExpandLess';
import FormatQuoteIcon from 'material-ui-icons/FormatQuote';

const style = {
	loading: {
		alignSelf: 'center',
		width: '75px',
		height: '75px',
		marginTop: 'calc(50vh - 37.5px - 64px)'
	}
};

export default class Applicants extends React.Component {
	constructor() {
		super();

		this.state = {
			loggedIn: false,
			authLoading: true,
			loading: true,
			snackStatus: false,
			snackMessage: '',
			applicantLoading: true,
			applicationLoading: true,
			jobLoading: true,
			offerLoading: true,
			applicantStatusLoading: true,
			endorsementsLoading: true,
			skillsLoading: true
		};
	}

	componentDidMount() {
		firebase.auth().onAuthStateChanged(user => {
			if (user) {
				this.getInfo();
				this.setState({
					uid: user.uid,
					user: user.providerData[0],
					jid: this.props.match.params.jid,
					loggedIn: true,
					authLoading: false,
					loading: true,
					jobLoading: true,
					offerLoading: true,
					endorsementsLoading: true,
					applicationLoading: true,
					skillsLoading: true
				});
			} else {
				firebase
					.database()
					.ref(`selection/${this.state.jid}/${this.state.uid}`)
					.off();
				this.setState({
					loggedIn: false,
					authLoading: false,
					loading: true,
					jobLoading: false,
					offerLoading: false,
					endorsementsLoading: false,
					applicationLoading: false,
					skillsLoading: false
				});
			}
		});
	}

	componentWillUnmount() {
		const { jid, uid } = this.state;
		firebase
			.database()
			.ref(`selection/${jid}/${uid}`)
			.off();
	}

	getInfo = () => {
		const { jid, uid } = this.props.match.params;
		const ref = firebase.database().ref();
		let promises = [];
		const jobPromise = firebase
			.firestore()
			.collection('jobs')
			.doc(jid)
			.get()
			.then(snap => {
				if (snap.data() !== null) {
					this.setState({
						job: snap.data(),
						jobLoading: false,
						loading: false
					});
				}
			});
		promises.push(jobPromise);
		const applicationPromise = ref
			.child(`applications/${jid}/${uid}`)
			.once('value')
			.then(snap => {
				if (snap.val() !== null) {
					firebase
						.firestore()
						.collection('offers')
						.doc(snap.val().oid)
						.get()
						.then(snapshot => {
							this.setState({
								application: snap.val(),
								applicationLoading: false,
								offer: snapshot.data(),
								offerLoading: false,
								loading: false
							});
						});
				}
			});
		promises.push(applicationPromise);
		const endorsementPromise = ref
			.child(`endorsements/${uid}/${jid}`)
			.once('value')
			.then(snap => {
				if (snap.val() !== null) {
					this.setAverageRating(snap.val());
					this.setState({
						endorsements: snap.val(),
						endorsementsLoading: false
					});
				}
			});
		promises.push(endorsementPromise);
		const skillsPromise = firebase
			.firestore()
			.collection('skills')
			.doc(uid)
			.get()
			.then(snap => {
				if (!!snap.data()) {
					this.setState({
						skills: snap.data(),
						skillsLoading: false
					});
				}
			});
		promises.push(skillsPromise);
		Promise.all(promises)
			.then(() => {
				this.setState({
					loading: false
				});
			})
			.catch(err => {
				this.setState({
					snackStatus: true,
					snackMessage: `Error: ${err.message}`
				});
			});
	};

	setAverageRating = endorsements => {
		let ratings = [];
		for (let endorsement in endorsements) {
			let e = endorsements[endorsement];
			ratings.push(e.rating);
		}
		const sum = ratings.reduce((a, b) => {
			return a + b;
		});
		const avg = sum / ratings.length;
		this.setState({ averageRating: avg });
	};

	renderJob = () => {
		const { job } = this.state;
		let html = [];
		let card = (
			<Fade key={job.jid} in={true}>
				<Card className="card">
					<JobCardHeader job={job} />
					{job.status !== 'published' && <Divider light />}
					{job.status !== 'published' && <UnpublishedJob status={job.status} />}
				</Card>
			</Fade>
		);
		html.push(card);
		return html;
	};

	renderApplicationEmbed = () => {
		const { application } = this.state;
		let html = [];
		let card = (
			<Fade key={`${application.jid}_${application.uid}`} in={true}>
				<Card className="card">
					<ApplicantCardHeader applicant={application} />
					<Divider light />
					{application.cv &&
						application.cv.downloadURLs &&
						application.cv.downloadURLs[0] && (
							<CardContent>
								<embed
									src={application.cv.downloadURLs[0]}
									style={{ width: '100%', height: '-webkit-fill-available' }}
									type="application/pdf"
								/>
							</CardContent>
						)}
					<Divider light />
					<CardActions className="cardActions">
						{application.linkedIn && (
							<a target="_blank" href={`${application.linkedIn}`}>
								<Button className="cardActionsBtn" raised>
									View LinkedIn
								</Button>
							</a>
						)}
						<a target="_blank" href={`${application.cv.downloadURLs[0]}`}>
							<Button className="cardActionsBtn" raised>
								View C.V.
							</Button>
						</a>
						<Link to={`/Chat/${this.state.application.uid}`}>
							<Button className="cardActionsBtn" raised>
								Chat
							</Button>
						</Link>
					</CardActions>
				</Card>
			</Fade>
		);
		html.push(card);
		return html;
	};

	renderOfferDetails = () => {
		const { offer } = this.state;
		let html = [];
		let card = (
			<Fade key={'referees'} in={true}>
				<Card className="card">
					<CardHeader subheader="This applicant was referred by the following users." />
					<JobCardReferees
						shareCount="hide"
						applicantUID={this.state.application.uid}
						applicantDisplayName={this.state.application.displayName}
						applicantPhotoURL={this.state.application.photoURL}
						photoURL={this.state.user.photoURL}
						users={offer.users}
						uid={this.state.uid}
						displayName={this.state.user.displayName}
					/>
				</Card>
			</Fade>
		);
		html.push(card);
		return html;
	};

	renderEndorsements = () => {
		let html = [];
		const { endorsements } = this.state;
		Object.keys(endorsements).forEach((endorsement, i) => {
			let listTitle = (
				<ListItem
					key={`${endorsement}_${i}_title`}
					disableRipple
					button
					onClick={() => {
						this.setState({
							[`${endorsement}`]: !this.state[`${endorsement}`]
						});
					}}
				>
					<ListItemText primary={endorsements[endorsement].rating.toFixed(2)} />
					{this.state[`${endorsement}`] ? (
						<ExpandLessIcon />
					) : (
						<ExpandMoreIcon />
					)}
				</ListItem>
			);
			html.push(listTitle);
			let listBody = (
				<Collapse
					key={`${endorsement}_${i}_body`}
					type="li"
					in={this.state[`${endorsement}`]}
					unmountOnExit
				>
					<List disablePadding>
						<ListItem>
							<ListItemIcon>
								<FormatQuoteIcon />
							</ListItemIcon>
							<ListItemText inset primary={endorsements[endorsement].about} />
						</ListItem>
					</List>
				</Collapse>
			);
			html.push(listBody);
		});
		return html;
	};

	renderSkills = () => {
		let html = [];
		let card = (
			<Card key="skills_card" className="card">
				<CardContent className="skillsChipsContent">
					<SkillsChips skills={this.state.skills} />
				</CardContent>
			</Card>
		);
		html.push(card);
		return html;
	};

	closeSnack = () => this.setState({ snackStatus: false, snackMessage: '' })

	render() {
		console.log(this.state);
		return (
			<React.Fragment>
				<Head title={`Applicant | ${Title}`} />
				<div id={this.state.loggedIn ? 'loggedInBody' : null} className="body">
					{(this.state.loading &&
						this.state.authLoading &&
						!this.state.loggedIn) ||
					(this.state.loading &&
						!this.state.authLoading &&
						this.state.loggedIn) ? (
						<CircularProgress style={style.loading} size={75} />
					) : null}

					{!this.state.loading &&
						!this.state.authLoading &&
						this.state.loggedIn &&
						!this.state.jobLoading && <SectionTitle title="Job Details" />}
					{!this.state.loading &&
						!this.state.authLoading &&
						this.state.loggedIn &&
						!this.state.jobLoading &&
						this.renderJob()}

					{!this.state.loading &&
						!this.state.authLoading &&
						this.state.loggedIn &&
						!this.state.applicationLoading && (
							<SectionTitle title="Application" />
						)}
					{!this.state.loading &&
						!this.state.authLoading &&
						this.state.loggedIn &&
						!this.state.applicationLoading &&
						this.renderApplicationEmbed()}

					{!this.state.loading &&
						!this.state.authLoading &&
						this.state.loggedIn &&
						!this.state.offerLoading && (
							<SectionTitle title="Recruitment Attribution" />
						)}
					{!this.state.loading &&
						!this.state.authLoading &&
						this.state.loggedIn &&
						!this.state.offerLoading &&
						this.renderOfferDetails()}

					{!this.state.loading &&
						!this.state.authLoading &&
						this.state.loggedIn &&
						!this.state.endorsementsLoading && (
							<SectionTitle title="Endorsements" />
						)}
					{!this.state.loading &&
						!this.state.authLoading &&
						this.state.loggedIn &&
						!this.state.endorsementsLoading && (
							<Fade in={true}>
								<Card className="card">
									<List
										subheader={
											<ListSubheader>
												Net Promoter Score:{' '}
												{this.state.averageRating
													? `${this.state.averageRating.toFixed(2)}`
													: null}
											</ListSubheader>
										}
									>
										{this.renderEndorsements()}
									</List>
								</Card>
							</Fade>
						)}

					{!this.state.loading &&
						!this.state.authLoading &&
						this.state.loggedIn &&
						!this.state.skillsLoading && (
							<SectionTitle title="Applicant Skills" />
						)}
					{!this.state.loading &&
						!this.state.authLoading &&
						this.state.loggedIn &&
						!this.state.skillsLoading &&
						this.renderSkills()}

					{this.state.loading &&
					!this.state.authLoading &&
					!this.state.loggedIn ? (
						<LoggedOutCard />
					) : null}

					<Snack
						snackStatus={this.state.snackStatus}
						snackMessage={this.state.snackMessage}
						closeSnack={() => {
							this.closeSnack();
						}}
					/>
				</div>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/Applicant.js